<template>
  <div class="flex flex-col justify-between md:h-full">
    <div>
      <div class="menu-item-label mt-4 mb-2">Основное</div>
      <div
        class="menu-item p-4 md:p-0"
        @click="
          !isDesktop &&
          navigateTo('/catalog', { open: { target: '_blank' } }) &&
          emit('close-menu')
        "
      >
        <div
          class="cursor-pointer"
          @click="isDesktop && navigateTo('/catalog', { open: { target: '_blank' } })"
        >
          <UINewIconsICart class="fill-txprimary" />
          <span class="text-txprimary font-normal">Каталог</span>
        </div>
      </div>
      <div
        class="menu-item p-4 md:p-0"
        :class="{ active: isActive('/publisher') }"
        @click="!isDesktop && navigateTo('/publisher') && emit('close-menu')"
      >
        <div class="">
          <UINewIconsIBentoFour :fill="isActive('/publisher') ? '#3176FF' : '#3A3D44'" />
          <NuxtLink
            to="/publisher"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher') }"
            @click="emit('close-menu')"
            >Мои каналы</NuxtLink
          >
        </div>
      </div>
      <div
        class="menu-item p-4 md:p-0"
        :class="{ active: isActive('/publisher/orders') }"
        @click="!isDesktop && navigateTo('/publisher/orders') && emit('close-menu')"
      >
        <div>
          <UINewIconsIOrders :fill="isActive('/publisher/orders') ? '#3176FF' : '#3A3D44'" />
          <NuxtLink
            to="/publisher/orders"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher/orders') }"
            @click="emit('close-menu')"
            >Заказы</NuxtLink
          >
        </div>
        <div v-if="orderStore.publicationCount.new > 0">
          <div class="bg-primary/10 rounded-xl px-2 py-0.5 text-primary font-bold text-md">
            +{{ orderStore.publicationCount.new }}
          </div>
        </div>
      </div>
      <div
        class="menu-item"
        :class="{ active: isActive('/publisher/dialogs') }"
        @click="!isDesktop && navigateTo('/publisher/dialogs') && emit('close-menu')"
      >
        <div>
          <UINewIconsIMessages
            :class="isActive('/publisher/dialogs') ? 'fill-primary' : 'fill-txprimary'"
          />
          <NuxtLink
            to="/publisher/dialogs"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher/dialogs') }"
            @click="emit('close-menu')"
            >Диалоги</NuxtLink
          >
        </div>
      </div>
      <NuxtLink
        to="/publisher/showcase"
        class="mt-4 mb-8 flex !w-full flex-row items-center justify-between bg-white p-2 md:rounded-xl cursor-pointer ml-0 md:-ml-2 !px-4 md:p-2 border border-border"
        :class="{ '!bg-primary/10': isActive('/publisher/showcase') }"
        @click="emit('close-menu')"
      >
        <div class="">
          <div class="flex flex-row items-center gap-3">
            <UINewIconsITopics />
            Витрина
          </div>
        </div>
        <UINewIconsILinkArrow class="fill-txopacity size-5" />
      </NuxtLink>

      <div class="menu-item-label mb-2">Настройки</div>
      <div
        class="menu-item"
        :class="{ active: isActive('/publisher/reports') }"
        @click="!isDesktop && navigateTo('/publisher/reports') && emit('close-menu')"
      >
        <div>
          <Icon
            name="mdi:clipboard-text-time"
            size="24"
            :class="{ 'text-primary': isActive('/publisher/reports') }"
          />
          <NuxtLink
            to="/publisher/reports"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher/reports') }"
            @click="emit('close-menu')"
            >Отчеты и документы</NuxtLink
          >
        </div>
      </div>
      <div
        class="menu-item"
        :class="{ active: isActive('/publisher/payments') }"
        @click="!isDesktop && navigateTo('/publisher/payments') && emit('close-menu')"
      >
        <div>
          <UINewIconsICardBalance
            :current-color="isActive('/publisher/payments') ? '#3176FF' : '#3A3D44'"
          />
          <NuxtLink
            to="/publisher/payments"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher/payments') }"
            @click="emit('close-menu')"
            >Выплаты</NuxtLink
          >
        </div>
      </div>
      <div
        class="menu-item"
        :class="{ active: isActive('/publisher/settings') }"
        @click="!isDesktop && navigateTo('/publisher/settings') && emit('close-menu')"
      >
        <div>
          <UINewIconsISettings
            :class="isActive('/publisher/settings') ? 'fill-primary' : 'fill-txprimary'"
          />
          <NuxtLink
            to="/publisher/settings"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/publisher/settings') }"
            @click="emit('close-menu')"
            >Настройки</NuxtLink
          >
        </div>
      </div>
      <div class="menu-item-label mt-2 mb-2">Сервис</div>
      <div
        class="menu-item"
        @click="
          !isDesktop &&
          navigateTo('https://t.me/TelePost_news', { open: { target: '_blank' } }) &&
          emit('close-menu')
        "
      >
        <div
          class="cursor-pointer"
          @click="
            isDesktop && navigateTo('https://t.me/TelePost_news', { open: { target: '_blank' } })
          "
        >
          <UINewIconsINews />
          Новости
        </div>
      </div>
      <div
        class="menu-item"
        :class="{ active: isActive('/blog') }"
        @click="!isDesktop && navigateTo('/blog') && emit('close-menu')"
      >
        <div>
          <UINewIconsIDoc :class="isActive('/blog') ? 'fill-primary' : 'fill-txprimary'" />
          <NuxtLink
            to="/blog"
            class="text-txprimary font-normal"
            :class="{ '!text-primary !font-semibold': isActive('/blog') }"
            @click="emit('close-menu')"
            >Блог</NuxtLink
          >
        </div>
      </div>
      <div
        class="menu-item"
        :class="{
          active: isActive('/publisher/help') || isActive('/publisher/help/faq'),
        }"
        @click="!isDesktop && navigateTo('/publisher/help') && emit('close-menu')"
      >
        <div>
          <UINewIconsIHelp
            class="ml-1"
            :class="
              isActive('/publisher/help') || isActive('/publisher/help/faq')
                ? 'fill-primary'
                : 'fill-txprimary'
            "
          />
          <NuxtLink
            to="/publisher/help"
            class="text-txprimary font-normal"
            :class="{
              '!text-primary !font-semibold':
                isActive('/publisher/help') || isActive('/publisher/help/faq'),
            }"
            @click="emit('close-menu')"
            >Помощь</NuxtLink
          >
        </div>
      </div>
      <div class="menu-item cursor-pointer" @click="openSC">
        <div>
          <UINewIconsIResponseTime />
          Поддержка
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-3.5 items-center pt-8 pb-16">
      <NuxtLink
        to="/pdf/politic.pdf"
        target="_blank"
        class="text-txsecondary text-xs font-normal text-center"
      >
        Политика конфиденциальности
      </NuxtLink>
      <NuxtLink to="/publisher/documents" class="text-txsecondary text-xs font-normal text-center">
        Юридические документы
      </NuxtLink>
    </div>
  </div>
  <!-- SUPPRT CHAT MODAL -->
  <!-- <EmptyModal
    :open="showSupportChatModal"
    @update:open="showSupportChatModal = $event"
    classes="!bg-white"
    width="90%"
  >
    <SupportChatModal />
  </EmptyModal> -->
</template>
<script lang="ts" setup>
  import { usePublisherOrdersStore } from "~/store/PublisherOrdersModule";
  import { useScreenSize } from "~/helpers/isMobile";
  import { useSupportChat } from "~/composables/useSupportChat";

  const { isDesktop } = useScreenSize();
  // const openSupportChatModal = ref(false);
  const { openSC } = useSupportChat();

  const route = useRoute();
  const isActive = (path: string) => route.path === path;

  const emit = defineEmits<{
    (e: "close-menu"): void;
  }>();

  const orderStore = usePublisherOrdersStore();
</script>

<style scoped lang="scss">
  .menu-item {
    @apply flex flex-row items-center justify-between text-sm text-txprimary gap-3 mb-0 md:mb-8 p-4 md:p-0;

    & > div {
      @apply flex flex-row gap-3 items-center justify-between;
    }

    &.active {
      @apply bg-primary/10 md:bg-transparent;
    }
  }
  .menu-item-label {
    @apply text-txprimary/60 text-sm md:mb-8 mt-4 pt-4 pl-4 md:p-0;
  }
</style>
